import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";

import { FeatureItem } from "./FeatureItem";
import { IExtractImagesFromXDFeaturesSection } from "./types";

type IProps = IExtractImagesFromXDFeaturesSection;

export const ExtractImagesFromXDFeaturesSection: React.FC<IProps> = ({
  title,
  items,
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();

  return (
    <Grid
      customStyle={{
        flexDirection: "column",
        alignItems: "center",
        padding: "40px 20px",
        [bp.FROM_DESKTOP]: {
          padding: "88px 20px 111px",
        },
      }}
      wrapperStyle={{ backgroundColor: colors.WHITE }}
    >
      <Heading
        as="h3"
        customStyle={{
          fontSize: 36,
          lineHeight: "48px",
          marginBottom: 32,
          letterSpacing: "-0.02rem",
          color: colors.DARK_GREY,
          fontWeight: 700,
          textAlign: "center",
          [bp.FROM_DESKTOP]: {
            maxWidth: 620,
            fontSize: 48,
            lineHeight: "60px",
            marginBottom: 64,
          },
        }}
      >
        {title}
      </Heading>

      <div
        className={css({
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: 20,
          [bp.FROM_TABLET]: {
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 45,
          },
        })}
      >
        {items.map(({ title, description, icon, iconColor }) => (
          <FeatureItem
            key={`extract_image_from_xd_feature_item_${title.replace(
              " ",
              "_",
            )}`}
            title={title}
            description={description}
            icon={icon}
            iconColor={iconColor}
          />
        ))}
      </div>
    </Grid>
  );
};
